module.exports = __webpack_public_path__ + "static/media/03-PICKUP_STALL.19082202.png";